// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__z6NZi","content":"styles_content__3wp2N","checkbox":"styles_checkbox__3KFb6","checkboxLabel":"styles_checkboxLabel__WmsqW"};